import { AggrupationActionStatusType } from "@/constants/aggrupation-action.constants";
import { PaginateAndSortByFiltersDto } from "../common.model";

export enum CustomerAggrupationProcessStatus {
	GROUPED = "grouped",
	BROKEN = "broken",
	SENT = "sent",
	COMPLETED = "completed"
}

export interface CustomerAggrupation {
	id: number;
	customerId: string;
	status: AggrupationActionStatusType;
	shoppingCartId: string;
	channel: string;
	customerVulnerable: boolean;
	digitelCircuitType: string;
	contractId: string;
	created: {
		by: string;
		inChannel: string;
		at: string;
	};
	updated: {
		by: string;
		inChannel: string;
		at: string;
	};
}

export interface CreateCustomerAggrupation {
	cusotmerId: string;
	channel: string;
	customerVulnerable: boolean;
	digitelCircuitType: string;
}

export interface CustomersAggrupationsFiltersDto extends PaginateAndSortByFiltersDto {
	id?: string;
	customerId?: string;
	user?: string;
	channel?: string;
	status?: string;
	dateFrom?: string;
	dateTo?: string;
}

export interface CustomerAggrupationSubmitProcessResDto {
	id: number;
	customerProcessId: string;
	customerProcessType: string;
	status: CustomerAggrupationProcessStatus;
	error?: any;
}

export interface CustomerAggrupationSubmitProcessesResDto {
	newExtrasProcesses: CustomerAggrupationSubmitProcessResDto[];
	deactivationProcesses: CustomerAggrupationSubmitProcessResDto[];
	modificationProcesses: CustomerAggrupationSubmitProcessResDto[];
	transitionProcesses: CustomerAggrupationSubmitProcessResDto[];
	multipleTransitionProcesses: CustomerAggrupationSubmitProcessResDto[];
}
